import { APP_NAME } from './branding';

export const LEGAL = {
  productName: APP_NAME,
  companyName: process.env.REACT_APP_LEGAL_COMPANY_NAME || `${APP_NAME} Ltd`,
  contactEmail: process.env.REACT_APP_LEGAL_CONTACT_EMAIL || 'privacy@yourdomain.com',
  dpoEmail: process.env.REACT_APP_LEGAL_DPO_EMAIL || 'privacy@yourdomain.com',
  lastUpdated: '21 July 2026',
  governingLaw: 'England and Wales',
} as const;

export const COOKIE_CONSENT_KEY = 'powerflow_cookie_consent';

export type CookieConsent = {
  essential: true;
  analytics: boolean;
  consentedAt: string;
};

export const LEGAL_DISCLAIMER =
  'This document is provided as a template for operational use. It does not constitute legal advice. Have it reviewed by qualified counsel before relying on it for regulatory compliance.';
